import { FC } from 'react';
import strings from '../../../../common/Translation/Translate';
import axiosInstance from '../../../../utils/axios';
import { URLS } from '../../../../utils/constants/urls';
import { createDropdownData } from '../../../../utils/validators/HelperFunctions';
import IdsMappingList, { IdsMappingListConfig } from '../shared/IdsMappingList';
import { optionLabel, optionValue } from '../shared/idsMappingTableCells';
import { AddEditEventMappingsForm } from './AddEditEventMappings/AddEditEventMappingsForm';

const eventMappingConfig: IdsMappingListConfig = {
  kind: 'event',
  title: 'Event Mappings',
  subtitle: 'Map BBR event types to IDS event names and codes.',
  addButtonText: 'Add Event Mapping',
  addDrawerTitle: 'Add Event Mapping',
  editDrawerTitle: 'Edit Event Mapping',
  searchPlaceholder: 'Search by IDS name or code',
  entityLabel: 'Event mappings',
  listApi: URLS.eventMappings,
  addApi: URLS.addEventMapping,
  getById: URLS.getEventMappingById,
  saveApi: URLS.editEventMapping,
  deleteApi: URLS.deleteEventMapping,
  importApi: URLS.importEventMappings,
  downloadImportTemplate: URLS.downloadEventMappingsTemplate,
  bbrHeader: 'BBR Event',
  idsHeader: 'IDS Event',
  idsSortField: 'eventName',
  getBbrLabel: row => optionLabel(row.eventType) || '—',
  getIdsName: row => row.eventName,
  getIdsCode: row => row.eventCode,
  formModel: options => AddEditEventMappingsForm(strings, options),
  emptyFormValues: { eventType: '', eventName: '', eventCode: '' },
  loadDropdownOptions: async () => {
    const { data, status } = await axiosInstance.get(URLS.getEventTypeList);
    if (status === 200 && data?.length > 0) {
      return createDropdownData(data, ['id', 'name']);
    }
    return [];
  },
  mapResponseToForm: data => ({
    eventType: data.eventType || '',
    eventName: data.eventName || '',
    eventCode: data.eventCode || '',
  }),
  mapFormToPayload: body => ({
    eventTypeId: optionValue(body.eventType),
    eventName: body.eventName,
    eventCode: body.eventCode,
  }),
  getDeleteEntityName: values => optionLabel(values.eventType) || String(values.eventName || ''),
};

const EventMappingsList: FC = () => <IdsMappingList config={eventMappingConfig} />;

export default EventMappingsList;
